<template>
  <span class="position-text-container" :class="device.isMobile ? 'position-text-container-mobile' : ''" @click.stop="guideHandle">
    <span class="text">{{ content.text }}</span>
    <img class="img" :src="require('@/assets/images/books/book1/workOrder/guide.png')" alt="">
  </span>
</template>

<script>
/*
定位组件
*/
export default {
  name: "positionText",
  inject: [ 'saveHistoryPosition', 'chapterChange' ],
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods: {
    async guideHandle() {
      if(this.content.isLock === 1) {
        this.$message.error('请先解锁该章节！')
        return false;
      }
      await this.saveHistoryPosition()
      await this.chapterChange(this.content.guideChapter, true)
      
      this.$nextTick(() => {
        setTimeout(()=> {
          // 导航滚动定位
          const element = document.getElementById(this.content.guide);
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth', // 平滑滚动
              block: "start", // 顶部对齐
            });
          }
        }, 20);
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.position-text-container{
  font-style: normal;
  user-select: none;
  color: #0482EC;
  vertical-align: middle;
  cursor: pointer;

  .text{
    font-size: 24rem;
    line-height: 40rem;
    font-style: normal;
    vertical-align: middle;
    font-family: Calibri;
  }
  .img{
    width: 32rem;
    height: 32rem;
    display: inline-block;
    vertical-align: middle;
    margin: 0 5rem;
  }

    &:after{
      content: '';
      width: 32rem;
      height: 32rem;
      position: absolute;
      right: 0;
      bottom: 0;
      background: url() center center no-repeat;
      background-size: contain;
    }
}
.position-text-container-mobile{
  .text{
    font-size: 28rem;
  }
}
</style>